import { render, staticRenderFns } from "./gameSelect.vue?vue&type=template&id=780eb4ab&"
import script from "./gameSelect.vue?vue&type=script&lang=js&"
export * from "./gameSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780eb4ab')) {
      api.createRecord('780eb4ab', component.options)
    } else {
      api.reload('780eb4ab', component.options)
    }
    module.hot.accept("./gameSelect.vue?vue&type=template&id=780eb4ab&", function () {
      api.rerender('780eb4ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/game/components/gameSelect.vue"
export default component.exports